(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    function loadRelatedCrossSell() {
    document.querySelectorAll('[data-related-crosssell]').forEach((container) => {
      if (container.dataset.loaded === 'true') {
        return;
      }

      container.dataset.loaded = 'true';

      const grid = container.querySelector('[data-related-crosssell-grid]');
      const productId = container.dataset.productId;
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const endpoint = root + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=related';

      fetch(endpoint)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Recommendations request failed');
          }

          return response.json();
        })
        .then((data) => {
          const products = Array.isArray(data.products) ? data.products.slice(0, 6) : [];

          if (products.length === 0) {
            return;
          }

          const locale = document.documentElement.lang || 'de-DE';
          const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
            ? window.Shopify.currency.active
            : 'EUR';
          const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
          });

          products.forEach((relatedProduct) => {
            const card = document.createElement('a');
            card.className = 'related-crosssell__card';
            card.href = root + 'products/' + relatedProduct.handle;

            const imageWrap = document.createElement('div');
            imageWrap.className = 'related-crosssell__image-wrap';

            const sourceImage = relatedProduct.featured_image || (Array.isArray(relatedProduct.images) ? relatedProduct.images[0] : null);

            if (sourceImage) {
              const image = document.createElement('img');
              image.className = 'related-crosssell__image';
              image.loading = 'lazy';
              image.alt = relatedProduct.title || '';
              image.width = 320;
              image.height = 320;

              try {
                const imageUrl = new URL(sourceImage, window.location.origin);
                imageUrl.searchParams.set('width', '320');
                image.src = imageUrl.toString();
              } catch (error) {
                image.src = sourceImage;
              }

              imageWrap.appendChild(image);
            }

            const title = document.createElement('div');
            title.className = 'related-crosssell__title';
            title.textContent = relatedProduct.title || '';

            const price = document.createElement('div');
            price.className = 'related-crosssell__price';
            const rawPrice = Number(relatedProduct.price_min || relatedProduct.price || 0);
            price.textContent = formatter.format(rawPrice / 100);

            card.appendChild(imageWrap);
            card.appendChild(title);
            card.appendChild(price);
            grid.appendChild(card);
          });

          container.hidden = false;
        })
        .catch(() => {
          container.hidden = true;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRelatedCrossSell, { once: true });
  } else {
    loadRelatedCrossSell();
  }

  document.addEventListener('shopify:section:load', loadRelatedCrossSell);
  } catch(e) { console.error(e); }
})();

})();
